import type {
  CommonResponseListExamProblemWithProblemResponse,
  DownloadCertificatesParams,
  DownloadExamReportData,
  DownloadExamReportParams,
  GetExamSchedulesByData,
} from '~/api-spec/__generated__/main'
import { httpClient, type HttpFile, type RequestMeta } from '~/http/client'

import { adaptExamProblems, adaptExamReportFile, adaptExamSchedules } from './adapters'
import type { Exam, ExamProblem, ExamReportFile, ExamSchedule, ExamType } from './schemas'

export type ExamReportParams = DownloadExamReportParams
export type ExamCertificatesParams = DownloadCertificatesParams

export const getExamProblems = async (
  examId: Exam['id'],
  meta?: RequestMeta,
): Promise<ExamProblem[]> => {
  const body = await httpClient().get<CommonResponseListExamProblemWithProblemResponse>(
    `/exam/${examId}/problem`,
    { meta },
  )
  return adaptExamProblems(body.data) ?? []
}

export const getExamSchedules = async (
  type: ExamType,
  meta?: RequestMeta,
): Promise<ExamSchedule[]> => {
  const body = await httpClient().get<GetExamSchedulesByData>('/exam/schedule', {
    params: { type },
    meta,
  })
  return adaptExamSchedules(body)
}

/** 시험·학생·회차 단위 결과지를 내려받을 주소 */
export const getExamReportFile = async (
  params: ExamReportParams,
  meta?: RequestMeta,
): Promise<ExamReportFile> => {
  const body = await httpClient().get<DownloadExamReportData>('/exam/download', { params, meta })
  return adaptExamReportFile(body)
}

/** 회차의 상장을 zip 하나로 내려받는다 */
export const getExamCertificatesFile = async (
  params: ExamCertificatesParams,
  meta?: RequestMeta,
): Promise<HttpFile> => httpClient().getFile('/v1/exams/certificates/download', { params, meta })
